import Alpine from "alpinejs";

document.addEventListener('alpine:init', () => {
    Alpine.data('initReleases', (releases, artistNames) => ({
        search: '',
        releaseTypeFilter: '',
        releaseStatusFilter: '',
        artistNameFilter: '',
        releases: releases,
        artistNames: artistNames,
        get filteredReleases() {

            return this.releases.filter(release => {
                let lowercaseSearch = this.search.toLowerCase();
                return this.isIncludedInSearch(release, lowercaseSearch)
                    && this.isIncludedInReleaseTypeFilter(release, this.releaseTypeFilter)
                    && this.isIncludedInReleaseStatusFilter(release, this.releaseStatusFilter)
                    && this.isIncludedInArtistNameFilter(release, this.artistNameFilter)
                ;
            });
        },
        isIncludedInSearch(release, search) {
            return release.name?.toLowerCase().includes(search)
                || release.display_artist?.toLowerCase().includes(search)
                || release.upc?.toString().includes(search)
                || release.ISRCsOfSongs?.toString()?.toString()?.includes(search);
        },
        isIncludedInReleaseTypeFilter(release, type) {
            if (!type) {
                return true;
            }
            return release.release_type === type;
        },
        isIncludedInReleaseStatusFilter(release, status) {
            if (!status) {
                return true;
            }
            return release.release_status_name === status;
        },
        isIncludedInArtistNameFilter(release, artistName) {
            if (!artistName) {
                return true;
            }
            return release.display_artist?.includes(artistName);
        }
    }))
});
